import React, { ChangeEvent, useState } from 'react';
import { FormField } from './FormField';

interface PasswordFieldProps {
    id: string;
    label: string;
    value: string | null | undefined;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    maxLength?: number;
    tooltip?: string;
    error?: string;
    className?: string;
    canToggleVisibility?: boolean;
    autoComplete?: string;
    name?: string;
    dataLpIgnore?: boolean;
    ariaAutoComplete?: string;
    inputMode?: string;
    list?: string;
}

export const PasswordField: React.FC<PasswordFieldProps> = ({
    id,
    label,
    value,
    onChange,
    disabled = false,
    maxLength,
    tooltip,
    error,
    className = '',
    canToggleVisibility = false,
    autoComplete,
    name,
    dataLpIgnore = false,
    ariaAutoComplete,
    inputMode,
    list
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const labelContent = canToggleVisibility ? (
        <div className="d-flex align-items-center">
            <label htmlFor={id} className="me-2">{label}</label>
            <i
                className="fas fa-eye fa-fw fa-xs"
                role="button"
                onClick={togglePasswordVisibility}
            />
        </div>
    ) : label;

    return (
        <FormField
            label={labelContent}
            id={id}
            tooltip={tooltip}
            error={error}
        >
            <input
                type={showPassword ? 'text' : 'password'}
                id={id}
                className={`form-control ${className}`}
                maxLength={maxLength}
                onChange={onChange}
                value={value || ''}
                disabled={disabled}
                autoComplete={autoComplete}
                name={name}
                data-lpignore={dataLpIgnore}
                aria-autocomplete={ariaAutoComplete as any}
                inputMode={inputMode as any}
                list={list}
            />
        </FormField>
    );
};
